import styled from "styled-components";

export const PrimaryHeading = styled.span`
    font-style: normal;
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 3rem;
`
export const SecondaryHeading = styled.span`
    font-style: normal;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 3rem;
`
export const TertiaryHeading = styled.span`
    font-style: normal;
    font-weight: 500;
    font-size: 1.3rem;
    line-height: 3rem;
`